// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-select-shared-entries {
  width: 900px;
}
.dialog-select-shared-entries__body {
  display: flex;
  flex-direction: column;
}
.dialog-select-shared-entries__filters {
  margin-bottom: var(--g-spacing-3);
}
.dialog-select-shared-entries__extend-filters {
  display: flex;
  gap: var(--g-spacing-2);
  align-items: center;
  margin-left: var(--g-spacing-2);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogSelectSharedEntry/DialogSelectSharedEntry.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;AACR;AAEI;EACI,iCAAA;AAAR;AAGI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;AADR","sourcesContent":[".dialog-select-shared-entries {\n  width: 900px;\n}\n.dialog-select-shared-entries__body {\n  display: flex;\n  flex-direction: column;\n}\n.dialog-select-shared-entries__filters {\n  margin-bottom: var(--g-spacing-3);\n}\n.dialog-select-shared-entries__extend-filters {\n  display: flex;\n  gap: var(--g-spacing-2);\n  align-items: center;\n  margin-left: var(--g-spacing-2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
